import axios from "axios"

function objectToFormData(obj, form = new FormData(), namespace = '') {
  for (let property in obj) {
    if (!obj.hasOwnProperty(property)) continue;

    const formKey = namespace ? `${namespace}[${property}]` : property;

    if (obj[property] instanceof Date) {
      form.append(formKey, obj[property].toISOString());
    } else if (obj[property] instanceof File || obj[property] instanceof Blob) {
      // Handle both File and Blob objects
      if (obj[property] instanceof Blob && !(obj[property] instanceof File)) {
        // Convert Blob to File with proper name and type
        const blobType = obj[property].type || 'audio/webm';
        // Derive extension from mimeType (e.g. audio/mp4 -> mp4, audio/webm -> webm)
        const ext = blobType.split('/')[1]?.split(';')[0] || 'webm';
        const file = new File([obj[property]], `recording.${ext}`, {
          type: blobType
        });
        form.append(formKey, file);
      } else {
        form.append(formKey, obj[property]);
      }
    } else if (typeof obj[property] === 'object' && obj[property] !== null) {
      objectToFormData(obj[property], form, formKey);
    } else {
      form.append(formKey, obj[property]);
    }
  }
  return form;
}

export const authenticatedAxiosInstance = (authToken, baseURL = null) => {
  if (!authToken) {
    console.error('JWT token is missing.');
    return null // If token is not found, we return null.
  }

  const axiosInstance = axios.create({
    baseURL: baseURL || process.env.REACT_APP_PUBLIC_BACKEND_URL, // Your API base URL
    headers: {
      authorization: `Bearer ${authToken}`, // Include the JWT token in the header
      // 'Content-Type': 'application/json', // Set the content type (optional)
      //'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  })
  return axiosInstance
}

export const fetchData = async (path, authToken) => {
  try {
    const axiosInstance = authenticatedAxiosInstance(authToken)
    const response = await axiosInstance?.get(path)
    return response
  } catch (error) {
    console.error('Error fetching data:', error.message)
    throw error
  }
}

export const updateData = async (path, authToken, data) => {
  try {
    const axiosInstance = authenticatedAxiosInstance(authToken)
    const response = await axiosInstance?.patch(path, data)
    return response
  } catch (error) {
    console.error('Error fetching data:', error.message)
    throw error
  }
}

export const insertData = async (path, authToken, data, baseURL = null) => {
  try {
    const axiosInstance = authenticatedAxiosInstance(authToken, baseURL)
    const formData = objectToFormData(data);

    const response = await axiosInstance?.post(path, formData)
    return response
  } catch (error) {
    console.error('Error fetching data:', error.message)
    throw error
  }
}

export const deleteData = async (path, authToken) => {
  try {
    const axiosInstance = await authenticatedAxiosInstance(authToken)
    const response = await axiosInstance?.delete(path)
    return response
  } catch (error) {
    console.error('Error fetching data:', error.message)
    throw error
  }
}
